// Mock data for 3A Capital website clone

export const heroSlides = [
  {
    id: 1,
    image: "https://static.wixstatic.com/media/89ced0_0052f5e71f5844f7b41669032b36b6ab~mv2.jpg/v1/fill/w_1902,h_645,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/medical-technology-digital-anatomy-healthcare-interface-human-body-model-futuristic-displa.jpg",
  },
  {
    id: 2,
    image: "https://static.wixstatic.com/media/89ced0_e695c9a617da4600bdb1afe9322ae4fb~mv2.jpg/v1/fill/w_1902,h_645,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/89ced0_e695c9a617da4600bdb1afe9322ae4fb~mv2.jpg",
  },
  {
    id: 3,
    image: "https://static.wixstatic.com/media/89ced0_ec3b0fe5c12841738071f264bbb46bce~mv2.jpg/v1/fill/w_1902,h_645,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/business-person-futuristic-business-environment.jpg",
  },
];

export const advantages = [
  {
    number: "01",
    title: "24/7 Scalability",
    desc: "Our intelligent systems handle surges in demand instantly, ensuring consistent service availability.",
    image:
      "https://static.wixstatic.com/media/89ced0_467db16c781a49ada25cd956aa87f8e5~mv2.jpg/v1/crop/x_0,y_0,w_5534,h_3381/fill/w_624,h_381,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/businessman-using-smart-phone-chatting-with-smart-ai-artificial-intelligence-digital-techn.jpg",
  },
  {
    number: "02",
    title: "Improved Accuracy",
    desc: "AI reduces human errors in data-heavy tasks, providing consistent quality and eliminating manual input mistakes.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
  },
  {
    number: "03",
    title: "Operational Efficiency",
    desc: "Automates repetitive work such as data entry and document processing, allowing teams to focus on strategic initiatives.",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80",
  },
  {
    number: "04",
    title: "Cost Reduction",
    desc: "Businesses often report 15% to 30% reduction in operational costs after implementation through optimized resource allocation.",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
  },
];

export const healthcareFeatures = [
  "Intelligent patient scheduling with automated optimization",
  "Seamless telehealth coordination and virtual care management",
  "Secure, centralized medical records handling",
  "Compliance-ready workflows ensuring regulatory adherence",
  "Reduced administrative workload through smart automation",
];

export const crossIndustryFeatures = [
  "Unified AI platform for multi-industry automation",
  "Smart sales funnel and customer journey optimization",
  "Advanced marketing automation and campaign management",
  "Streamlined HR onboarding and employee workflows",
  "Data-driven insights for smarter decision-making",
];

export const builderTools = [
  {
    title: "Healthcare Assistant",
    desc: "Specialized modules for patient scheduling, telehealth coordination, and medical records handling. Built to meet HIPAA and SOC 2 standards.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1000&q=80",
    cta: "START BUILDING",
  },
  {
    title: "Business Bot",
    desc: "Lead qualification, CRM integration, and support automation. Scalable AI agents that handle 24/7 inquiries across sales and service channels.",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1000&q=80",
    cta: "START BUILDING",
  },
];

export const integrations = [
  { title: "EHR SYSTEMS", tag: "INTEGRATION", detail: "Native connectors for Epic, Cerner, and Allscripts with HL7/FHIR support for seamless clinical data exchange." },
  { title: "CRM PLATFORMS", tag: "WORKFLOW", detail: "Salesforce, HubSpot, and Zoho integrations with bidirectional syncing and workflow triggers." },
  { title: "AI VENDORS", tag: "ENGINEERING", detail: "OpenAI, Anthropic, Google, and open-source model orchestration within a unified control plane." },
  { title: "PAYMENT GATEWAYS", tag: "SECURITY", detail: "Stripe, Square, and PayPal integrations with PCI-DSS compliant transaction handling." },
  { title: "HEALTHCARE HUBS", tag: "DATA", detail: "Connect with regional HIEs and specialty networks for unified patient data access." },
  { title: "MARKETING PLATFORMS", tag: "AUTOMATION", detail: "Mailchimp, Marketo, and ActiveCampaign automation with AI-driven segmentation." },
];

export const navLinks = [
  { label: "HOME", href: "#home" },
  { label: "BENEFITS", href: "#benefits" },
  { label: "SOLUTIONS", href: "#solutions" },
];
